// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__PWR98","footer":"ModalFilter_footer__2MhqC"};